export const materialTableLocalization = {
  body: {
    emptyDataSourceMessage: "Sin registros",
    addTooltip: "Agregar",
    deleteTooltip: "Eliminar",
    editTooltip: "Editar",
    editRow: {
      deleteText: "¿Está seguro de eliminar este registro?",
      cancelTooltip: "Cancelar",
      saveTooltip: "Guardar"
    }
  },
  header: { actions: "Acciones" },
  toolbar: { searchPlaceholder: "Buscar", searchTooltip: "Buscar" },
  pagination: {
    labelRowsSelect: "filas",
    labelDisplayedRows: "{from}-{to} de {count}",
    firstTooltip: "Primera página",
    previousTooltip: "Página anterior",
    nextTooltip: "Siguiente página",
    lastTooltip: "Última página"
  }
};
